import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'

export function MobileNavBar ({ children }: { children: React.ReactNode }) {
  const [isScrolled, setIsScrolled] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      const observer = new IntersectionObserver((entries) => {
        setIsScrolled(!entries[0].isIntersecting)
      })

      observer.observe(ref.current)

      return () => observer.disconnect()
    }
  }, [])

  return (
    <>
      <div ref={ref} />
      <div
        className={clsx('border-b bg-white py-2 px-4 sticky top-0 z-10 flex items-center justify-between gap-4 transition', {
          'border-gray-200': isScrolled,
          'border-transparent': !isScrolled,
        })}
      >
        {children}
      </div>
    </>
  )
}
